import template from './views/toolbox.tpl.html';

angular
    .module('festzelt-os.toolbox')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.toolbox', {
            url: '/toolbox',
            templateUrl: template,
            controller: 'ToolboxCtrl',
            controllerAs: 'toolbox'
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/toolbox/toolbox-routes.js